/** Cross-origin SSO handoff into the seller portal (separate origin, same API tokens). */
export function handoffToSellerPortal(sellerPortalOrigin: string, path = "/onboarding"): boolean {
  try {
    const base = new URL(sellerPortalOrigin);
    const access = localStorage.getItem("gaole_access");
    const refresh = localStorage.getItem("gaole_refresh");
    if (!access || !refresh) return false;
    const next = path.startsWith("/") ? path : `/${path}`;
    const callback = new URL("/auth/callback", base.origin);
    callback.hash = new URLSearchParams({ access, refresh, next }).toString();
    window.location.href = callback.toString();
    return true;
  } catch {
    return false;
  }
}
